










































































import Vue, { PropType } from 'vue'
import Role from '@/types/Role.interface'
import User, { UserRole } from '@/types/User.interface'
import { mapGetters } from 'vuex'
import PasswordVerificationRules from '@/components/PasswordVerificationRules.vue'
import TenantMembership from '@/types/TenantMembership.interface'
import { unmask } from '@/utility/helpers'
import UserLogo from '@/components/UserLogo.vue'
export default Vue.extend({
    components: { PasswordVerificationRules, UserLogo },
    props: {
        selectedUser: {
            type: Object as PropType<User>,
            default: null
        }
    },
    data() {
        return {
            exisitngUserFormRoleId: null,
            formData: null,
            newUser: {
                email: null,
                firstname: null,
                lastname: null,
                mobilephone: null,
                password: null,
                selectedRole: null
            },
            showPassword: false,
            spin: false
        }
    },
    computed: {
        ...mapGetters(['authIsAdmin', 'roles', 'user']),
        filteredRoles(): Role[] {
            //  If no roles, just return null
            if (!this.roles) return null

            //  Else, filter out support
            return this.roles.filter((x: Role) => x.permission != 4)
        },
        role: {
            get(): UserRole {
                return this.selectedUser
                    ? this.$store.getters.userRole(this.selectedUser)
                    : this.newUser.selectedRole
            },
            set(value: Role): void {
                //  If selectedUser exists (editing a user)
                if (this.selectedUser) {
                    //  Set data param to id value
                    this.exisitngUserFormRoleId = value.id

                    //  return
                    return
                }
                //  Else, set new user role to value
                this.newUser.selectedRole = value
            }
        },
        userIsAdmin(): boolean {
            return this.$store.getters.userIsAdmin(this.selectedUser)
        },
        userIsSelf(): boolean {
            return this.user.id === this.selectedUser.id
        },
        userMembership(): TenantMembership {
            return this.$store.getters.userMembership(this.selectedUser)
        },
        userOutranksSelected(): boolean {
            //  Check if the user has permission to change a user role (managers and admin only)
            const hasPermission = this.$store.getters.userOutranks(1)

            //  Get if the authenticated user outranks the selected user
            const outRanks = this.$store.getters.userOutranksUser(this.selectedUser)

            return !this.userIsSelf && hasPermission && outRanks
        },
        userRole(): UserRole {
            return this.$store.getters.userRole(this.selectedUser)
        }
    },
    mounted() {
        //  If selected user is included, we are editing so keep values
        if (this.selectedUser) {
            this.newUser = window._.cloneDeep(this.selectedUser)
            //  Set id to data value
            this.exisitngUserFormRoleId = this.role.id
            this.mobilephoneInit()
        }
    },
    methods: {
        mobilephoneInit(): void {
            //  If our mobile phone isn't set, just return
            if (!this.newUser.mobilephone) return

            //  Create our number sections
            const parts = this.newUser.mobilephone.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)

            //  Mask our value
            this.newUser.mobilephone = `(${parts[2]}) ${parts[3]}-${parts[4]}`
        },
        mobilephoneSet(value: string): string {
            //  If value is null, just return it
            if (!value) return value

            //  Unmask the value
            let phone = unmask(value, '(###) ###-####')

            //  Add the north american country code
            phone = `1${phone}`

            //  Return the formatted number
            return phone
        },
        async onPasswordReset(user: User): Promise<void> {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'password-reset-by-email',
                title: 'Reset Password',
                icon: 'mdi-account',
                props: {
                    email: user.email
                },
                color: 'primary',
                closeable: true,
                closeOnSubmit: true,
                callback: async (): Promise<void> => {
                    //  Request a password reset email be sent
                    const response = await this.$store.dispatch(
                        'usersPasswordResetSend',
                        user.id
                    )

                    //  If no response was returned, do nothing
                    if (!response) return

                    //  Else, pop notification
                    this.$store.dispatch('dialogOpen', {
                        type: 'MESSAGE',
                        title: 'Password Reset Sent',
                        text: `A password reset has been sent to ${user.email}. If the email is associated with an account it may take a few minutes for the email to arrive.`,
                        icon: 'mdi-check-circle',
                        color: 'primary'
                    })
                }
            })
        },
        passwordResetManually(user: User): void {
            //  Open up a form to change password
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'password-reset-form',
                title: 'Reset Password',
                icon: 'mdi-lock-reset',
                props: {
                    userId: user.id
                },
                closeable: true,
                closeOnSubmit: true
            })
        },
        popResetPassword(): void {
            //  Check if the user being handled is the current auth user
            const isSelf = this.selectedUser.id === this.$store.getters.user.id

            //  Check if the authenticated user outranks the user being handled
            const iOutrankUser = this.$store.getters.userOutranksUser(this.selectedUser)

            //  if the user beig edited is the one being authenticatied, pop reset password form
            if (isSelf) return this.passwordResetManually(this.selectedUser)

            //  If not self and outrank the user being edited, pop form to send the user an email
            if (!isSelf && iOutrankUser) this.onPasswordReset(this.selectedUser)
        },
        popRoleHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Permissions Explained',
                text: `MessageDesk supports 3 levels of permission: Admin, Manager, Operator.\n\n<b>Admin</b>: the creator of your MessageDesk account. This person has access to everything and is the only person who can update the account’s subscription. Each account can only have 1 Admin. To change this admin, please email support@messagedesk.com.\n\n<b>Manager</b>: Has the same level of feature access as the Admin but is not the point of contact for the account. They are prevented from updating the account’s phone number or payment details. This is great for teammates who need all-access to the platform.\n\n<b>Operator</b>: Has limited access to MessageDesk features. They are unable to delete existing contacts, create or edit SMS campaigns, and unable to upload contact data in bulk via CSV uploads. This is great for teammates who may need to send a Broadcast, manage the inbox or need to export information from MessageDesk.`,
                icon: 'bi-question-circle-fill',
                color: '#717171',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        },
        async submit(): Promise<boolean> {
            //  Validate our inputs
            const valid = await this.$validator.validateAll()

            //  If invalid, do nothing
            if (!valid) return

            //  Set our mobilephone
            const phone = this.mobilephoneSet(this.newUser.mobilephone)

            //  Method depends on if we are editing or not
            const method = this.selectedUser ? 'usersPut' : 'usersPost'

            //  Clone our user
            const clone = window._.cloneDeep(this.newUser)

            //  Change mobile phone to formatted phone
            clone.mobilephone = phone

            //  Start loading
            this.spin = true

            //  If selected user exists (editing) and userRole id does not match form id
            if (this.selectedUser && this.role.id != this.exisitngUserFormRoleId) {
                //  Construct payload
                const payload = {
                    id: this.userMembership.id,
                    role_id: this.exisitngUserFormRoleId
                }

                //  Send request to update tenant membership
                const resp = await this.$store.dispatch('tenantMembershipsPut', payload)

                //  If failed, do nothing
                if (!resp) return

                //  Else, update the currently selected membership
                Object.assign(this.userMembership, resp)

                //  Update our currently selected role too
                Object.assign(this.userRole, resp.role)
            }

            //  Create/edit our user
            const user = await this.$store.dispatch(method, clone)

            //  If this fails, do nothing
            if (!user) {
                this.spin = false
                return
            }

            //  Pop a dialog if creating
            if (!this.selectedUser) {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'User Creation Successful',
                    text: `User ${user.firstname} ${user.lastname} with email ${user.email} has been created. Please notify them to login with the password you set for them.`,
                    icon: 'mdi-check',
                    color: 'primary',
                    closeable: true
                })
            }

            //  If formdata exists, append id onto formdata and upload
            if (this.formData) {
                //  Add id to formdata
                this.formData.append('id', user.id)

                //  Upload our logo
                const response = await this.$refs.userLogo.uploadLogo(this.formData)

                //  Update our logo route to match
                user.logo_route = response.logo_route
            }

            //  Clear form data
            this.formData = null

            //  Stop spinning
            this.spin = false

            //  Else, emit the submit
            this.$emit('submit', user)
        },
        uploaded(formData: FormData): void {
            //  Store our image data
            this.formData = formData
        }
    }
})
